// extracted by mini-css-extract-plugin
module.exports = {"mainAsset":"MainAsset_mainAsset__14c0T","leftBox":"MainAsset_leftBox__1y879","rightBox":"MainAsset_rightBox__3fD1W","marketCap":"MainAsset_marketCap__3KmZA"};